var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBookmark = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 10,
  height: 12,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.654.278A2.325 2.325 0 0 0 .323 2.456a63.042 63.042 0 0 0 .041 8.227c.068.94 1.197 1.38 1.882.732L4.853 8.95a.214.214 0 0 1 .294 0l2.607 2.465c.685.648 1.815.208 1.882-.732.195-2.74.204-5.488.041-8.227A2.325 2.325 0 0 0 7.346.278H2.654Z",
  fill: "#58636A"
})));
export default SvgBookmark;